
                      <ng-container *ngIf="trialUser == 0">
 <p><strong>Hey {{ username }},</strong></p>
           
                <p>If you’re feeling unsure what to do next — you're not alone.</p>
           
                <p>I’m happy to walk you through placing your first order or just answer any questions you have. Just hit reply, and I’ll take care of the rest.</p>
           
                <p>Best,<br>
                Sarah</p>
                <br>
            <hr style="width:100%; border:0; height:1px; background:rgba(0, 123, 255, 0.2);">
 
             <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px;">
                <tr>
                    <td width="100" align="left" valign="top" style="padding-right: 10px;">
                        <img src="https://backend.skyscrapersnow.com/images/sarah.png" alt="Sarah A." width="97" height="124" style="border-radius: 8px; display: block;">
                    </td>
                    <td align="left" valign="top" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
                         <img src="https://backend.skyscrapersnow.com/images/sarah_sign.png" alt="Sarah A Signature" style="max-width: 82px;
    max-height: 34px;
    display: block;
    margin-bottom: 5px;">
                        <p style="font-weight: 500;
    font-size: 18px;
    color: #000000;

    text-align: left;
    margin: 0;">Sarah A.</p>
                        <p style="margin: 7px 0;
    color: #767E8C;
    font-size: 13px;
    text-align: left;">Student Support Specialist</p>
                        <table cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td valign="middle" style="padding: 0px;">
                                    <img src="https://backend.skyscrapersnow.com/images/globe.png" alt="Website" width="15" height="15" style="display: block;">
                                </td>
                                <td valign="middle" style="font-size: 13px;color: #767E8C; padding: 0px 0px 0px 5px;">
                                    <a href="https://' . $site_link_clean . '" style="color: #767E8C; text-decoration: none;">{{ sitename }}</a>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
                      </ng-container>
               

            <ng-container *ngIf="trialUser == 1">

                <div class="preheader">
                        No pitch — just here if you ever need help
                    </div>
                
                    <p>Hi {{ username }},</p>
                
                    <p>
                      I noticed you tried out {{ sitename | formatSitename }} recently — just wanted to say hey 👋<br>
                      I\'m Kate, part of the support team here. If you ever need help finishing an essay, structuring an argument, or even deciding between rewriting vs. starting from scratch — feel free to reply anytime.
                    </p>
                
                    <p>
                      No pressure — just here to help if you need a real human on your side.
                    </p>
                
                    <p>Talk soon,<br>
                    Kate</p>
                    <br>
                    <hr style="width:100%; border:0; height:1px; background:rgba(0, 123, 255, 0.2);">
    
                    <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px;">
                        <tr>
                            <td width="100" align="left" valign="top" style="padding-right: 10px;">
                                <img src="https://backend.skyscrapersnow.com/images/kate.png" alt="Kate A." width="97" height="124" style="border-radius: 8px; display: block;">
                            </td>
                            <td align="left" valign="top" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
                                 <img src="https://backend.skyscrapersnow.com/images/kate_sign.png" alt="Kate A Signature" style="max-width: 97px; max-height:46px; display: block; margin-bottom: 9px;">
                                <p style="margin: 0; font-weight: 500; font-size: 18px; color:#000000;">Kate A.</p>
                                <p style="margin: 9px 0; color: #767E8C; font-size: 13px;">Student Support Specialist</p>
                                <table cellpadding="0" cellspacing="0" border="0">
                                    <tr>
                                        <td valign="middle" style="padding-right: 5px;">
                                            <img src="https://backend.skyscrapersnow.com/images/globe.png" alt="Website" width="15" height="15" style="display: block;">
                                        </td>
                                        <td valign="middle" style="font-size: 13px; color: #767E8C;">
                                            <a href="https://'.$SETTING['site_link'].'" style="color: #767E8C; text-decoration: none;">{{ sitename }}</a>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
            </ng-container>